export default "__VITE_ASSET__DHoGCS9Z__"